import { useMemo } from 'react'
import * as THREE from 'three/webgpu'

/**
 * Converts all GLB materials to MeshStandardNodeMaterial (WebGPU/TSL-compatible).
 * Copies map and color from each original material.
 *
 * @param {object} materials - The materials object from useGLTF
 * @returns {{ nodeMats: object, getMat: (node) => MeshStandardNodeMaterial }}
 */
export function useNodeMaterials(materials) {
  const nodeMats = useMemo(() => {
    const result = {}
    for (const [name, mat] of Object.entries(materials)) {
      const nodeMat = new THREE.MeshStandardNodeMaterial()
      if (mat.map) nodeMat.map = mat.map
      nodeMat.color = mat.color?.clone() ?? new THREE.Color('white')
      result[name] = nodeMat
    }
    return result
  }, [materials])

  const getMat = (node) => nodeMats[node.material?.name] || Object.values(nodeMats)[0]

  return { nodeMats, getMat }
}
